import { render, staticRenderFns } from "./rewardList.vue?vue&type=template&id=6645b34d&scoped=true"
import script from "./rewardList.vue?vue&type=script&lang=js"
export * from "./rewardList.vue?vue&type=script&lang=js"
import style0 from "./rewardList.vue?vue&type=style&index=0&id=6645b34d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6645b34d",
  null
  
)

export default component.exports